import styled from "styled-components";

const A = styled.a`
  text-decoration: none;
  color: white;
  transition: 0.2s color;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default A;
